if (process.env.GATSBY_MOBILE) {
  require('./src/styles/global.mobile.css');
} else {
  require('./src/styles/global.desktop.css');
}
